import * as React from "react";
import { SVGProps, memo } from "react";
const SvgNavigationArrowLeft22Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={22}
    fill="none"
    role="img"
    {...props}
  >
    <path
      d="m9.037 2.45-7.772 7.772a1 1 0 0 0 0 1.415l7.685 7.685.707-.707L2.543 11.5H21v-1H2.401l7.343-7.342-.707-.707Z"
      fill="#666"
    />
  </svg>
);
const Memo = memo(SvgNavigationArrowLeft22Px);
export default Memo;
